export default "__VITE_ASSET__3d7ac87d__"